import { FC } from 'react';
import { Input } from 'antd';
import type { TextAreaProps } from 'antd/lib/input';
import styles from './index.module.scss';

const { TextArea } = Input;
const TextAreaCore: FC<TextAreaProps> = (props) => {
  const { placeholder } = props;
  return <TextArea placeholder={placeholder} {...props} className={styles['textArea']} />;
};

export default TextAreaCore;
